"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CustomGraphWrap = exports.NewCustomGraphWrap = exports.BorderedBanner = void 0;
const Section_1 = __importDefault(require("@/components/layout/Section"));
const Section_2 = require("@/components/Section");
const SimpleTable_1 = __importDefault(require("@/components/list/SimpleTable"));
const fetchData_1 = require("@/utils/fetchData");
const react_1 = __importStar(require("react"));
const react_router_dom_1 = require("react-router-dom");
const format_1 = require("@/utils/format");
const styled_components_1 = __importStar(require("styled-components"));
const themes_1 = require("@/theme/themes");
const origyn_art_ui_1 = require("@origyn/origyn-art-ui");
const authProvider_1 = require("@/components/authProvider/authProvider");
const HelmetTitle_1 = __importDefault(require("@/components/interactions/HelmetTitle"));
const aboutUs_1 = require("../aboutUs");
const IconLogo_1 = __importDefault(require("@/assets/icons/IconLogo"));
const react_2 = require("@connect2ic/react");
const actionsTo = {
    "b7caca859346f4350b7614f754f24c878890df143a24e1ac4aa0416f3fdfa54c": "Deposit"
};
const actionsFrom = {
    "7464e86bc7753d03d8062197ddbad63a295d25ec9e3cc1834fdf9a0580740ad5": "Withdraw Rewards",
    "b7caca859346f4350b7614f754f24c878890df143a24e1ac4aa0416f3fdfa54c": "Withdraw",
};
const UserTransactions = () => {
    const { principal, accountID, loggedIn, isLoading: authLoading, handleLogOut } = (0, react_1.useContext)(authProvider_1.AuthContext);
    const [timeseries, setTimeseries] = (0, react_1.useState)();
    const [history, setHistory] = (0, react_1.useState)();
    const [inFlow, setInFlow] = (0, react_1.useState)([]);
    const [outFlow, setOutFlow] = (0, react_1.useState)([]);
    const [governanceHistory, setGovernanceHistory] = (0, react_1.useState)();
    const [fullHistory, setFullHistory] = (0, react_1.useState)({});
    const [totalTransactionsAmount, setTotalTransactionsAmount] = (0, react_1.useState)(0);
    const [latestTransactions, setLatestTransactions] = (0, react_1.useState)(0);
    const [unstaked, setUnstaked] = (0, react_1.useState)(0n);
    const [staked, setStaked] = (0, react_1.useState)(0n);
    const [isLoading, setIsLoading] = (0, react_1.useState)(true);
    const [balance, setBalance] = (0, react_1.useState)(null);
    const [rewards, setRewards] = (0, react_1.useState)({ total: "0", redeemed: "0", balance: "0" });
    const isDarktheme = (0, react_router_dom_1.useOutletContext)();
    const [governanceActor] = (0, react_2.useCanister)('governance', { mode: 'connected' });
    const [vestingActor] = (0, react_2.useCanister)('vesting', { mode: 'connected' });
    const [ledgerActor] = (0, react_2.useCanister)('ledger', { mode: 'connected' });
    const getData = async () => {
        if (principal?.toString() === "2vxsx-fae") {
            handleLogOut();
            return;
        }
        const governanceBalance = await governanceActor.get_balances_v1_5([principal], false);
        const redeemedRewardsTotal = governanceBalance.staked.reduce((total, item) => {
            return total + item[1].redeemedRewards.reduce((t, v) => t + v.amount, 0n);
        }, 0n);
        const rewardsTotal = governanceBalance.staked.reduce((total, item) => {
            return total + item[1].rewards.reduce((t, v) => t + v.amount, 0n);
        }, 0n);
        setRewards({ balance: (0, format_1.formatNatAmount)(rewardsTotal), redeemed: (0, format_1.formatNatAmount)(redeemedRewardsTotal), total: (0, format_1.formatNatAmount)(redeemedRewardsTotal + rewardsTotal) });
        const vesting = await vestingActor.get_balances();
        console.log(governanceBalance, vesting);
        setIsLoading(true);
        try {
            const result = await Promise.all([
                (0, fetchData_1.getLedgerTimeseriesById)(accountID),
                (0, fetchData_1.getTransactionHistoryById)(accountID, 1, 10),
                (0, fetchData_1.getTransactionHistoryById)(accountID, 1, 10000),
            ]);
            const [timeseriesResult, historyResult, mostTransactions] = await Promise.all(result);
            const formatted = mostTransactions.data.reduce((prev, value) => {
                const unix = value.Date[0].props.timestamp;
                prev[unix] = value.amount[0].props.amount;
                return prev;
            }, {});
            const governanceTransactions = mostTransactions.data.filter((item) => item.from[0].props.id === "b7caca859346f4350b7614f754f24c878890df143a24e1ac4aa0416f3fdfa54c" || item.to[0].props.id === "b7caca859346f4350b7614f754f24c878890df143a24e1ac4aa0416f3fdfa54c" || item.from[0].props.id === "7464e86bc7753d03d8062197ddbad63a295d25ec9e3cc1834fdf9a0580740ad5");
            const inTrx = mostTransactions.data.filter((item) => item.from[0].props.id === accountID);
            const outTrx = mostTransactions.data.filter((item) => item.to[0].props.id === accountID);
            setInFlow(inTrx);
            setOutFlow(outTrx);
            setGovernanceHistory(governanceTransactions);
            const stakedTokensSum = governanceBalance.staked.reduce((acc, token) => {
                return acc + token[1].quantity;
            }, 0n);
            setUnstaked(governanceBalance.unstaked);
            setStaked(stakedTokensSum);
            setFullHistory(formatted);
            setTotalTransactionsAmount(mostTransactions.data.reduce((val, item) => {
                console.log(val, parseFloat(item.amount[0].props.amount.replace(',', '')), item);
                return val = val + parseFloat(item.amount[0].props.amount.replace(/,/g, ''));
            }, 0));
            const history = historyResult;
            const timeseries = timeseriesResult;
            setBalance(timeseriesResult.balance[timeseriesResult.balance.length - 1].balance);
            setHistory(history);
            setLatestTransactions(history);
            setTimeseries(timeseries);
            setIsLoading(false);
        }
        catch (e) {
            console.log(e);
        }
    };
    const getTransactions = async (p, c) => {
        return (0, fetchData_1.getTransactionHistoryById)(accountID, p, c);
    };
    (0, react_1.useEffect)(() => {
        getData();
    }, [accountID]);
    return (react_1.default.createElement(Section_2.Section, null,
        react_1.default.createElement(HelmetTitle_1.default, { title: 'OGY Transactions', description: 'Your transactions' }),
        react_1.default.createElement("h1", null, "Transactions"),
        react_1.default.createElement("br", null),
        !isLoading && (react_1.default.createElement(react_1.default.Fragment, null,
            react_1.default.createElement(origyn_art_ui_1.Card, { flexFlow: "column", bgColor: "BACKGROUND" },
                react_1.default.createElement(origyn_art_ui_1.Banner, { fullWidth: true, padding: "24px" },
                    react_1.default.createElement(origyn_art_ui_1.Grid, { style: { width: "100%" }, columns: 3, gap: 24 },
                        react_1.default.createElement(origyn_art_ui_1.Flex, { fullWidth: true, flexFlow: "column", align: "center", gap: 24 },
                            react_1.default.createElement("h4", null, "Total Transactions"),
                            react_1.default.createElement("h2", null, history?.totalNumber)),
                        react_1.default.createElement(origyn_art_ui_1.Flex, { fullWidth: true, flexFlow: "column", align: "center", gap: 24 },
                            react_1.default.createElement("h4", null, "Total Transfer Amount"),
                            react_1.default.createElement(origyn_art_ui_1.Flex, { as: "h2", gap: 8 },
                                totalTransactionsAmount?.toFixed(4),
                                "  ",
                                react_1.default.createElement(aboutUs_1.CustomIcon, { size: "21" },
                                    react_1.default.createElement(IconLogo_1.default, null)),
                                " ",
                                react_1.default.createElement("span", null, "OGY"))),
                        react_1.default.createElement(origyn_art_ui_1.Flex, { fullWidth: true, flexFlow: "column", align: "center", gap: 24 },
                            react_1.default.createElement("h4", null, "Burned fees"),
                            react_1.default.createElement(origyn_art_ui_1.Flex, { as: "h2", gap: 8 },
                                (history?.totalNumber * 0.002).toFixed(4),
                                "  ",
                                react_1.default.createElement(aboutUs_1.CustomIcon, { size: "21" },
                                    react_1.default.createElement(IconLogo_1.default, null)),
                                " ",
                                react_1.default.createElement("span", null, "OGY")))))),
            react_1.default.createElement("br", null),
            react_1.default.createElement("h1", null, "Governance Overview"),
            react_1.default.createElement("br", null),
            react_1.default.createElement(origyn_art_ui_1.Card, { flexFlow: "column", bgColor: "BACKGROUND" },
                react_1.default.createElement(origyn_art_ui_1.Banner, { fullWidth: true, padding: "24px" },
                    react_1.default.createElement(origyn_art_ui_1.Grid, { style: { width: "100%" }, columns: 3, gap: 24 },
                        react_1.default.createElement(origyn_art_ui_1.Flex, { fullWidth: true, flexFlow: "column", align: "center", gap: 24 },
                            react_1.default.createElement("h4", null, "Governance balance"),
                            react_1.default.createElement("h2", null, (0, format_1.formatNatAmount)(staked + unstaked))),
                        react_1.default.createElement(origyn_art_ui_1.Flex, { fullWidth: true, flexFlow: "column", align: "center", gap: 24 },
                            react_1.default.createElement("h4", null, "Staked tokens"),
                            react_1.default.createElement(origyn_art_ui_1.Flex, { as: "h2", gap: 8 }, (0, format_1.formatNatAmount)(staked))),
                        react_1.default.createElement(origyn_art_ui_1.Flex, { fullWidth: true, flexFlow: "column", align: "center", gap: 24 },
                            react_1.default.createElement("h4", null, "Unstaked tokens"),
                            react_1.default.createElement(origyn_art_ui_1.Flex, { as: "h2", gap: 8 }, (0, format_1.formatNatAmount)(unstaked))))),
                react_1.default.createElement(origyn_art_ui_1.HR, null),
                react_1.default.createElement(origyn_art_ui_1.Banner, { fullWidth: true, padding: "24px" },
                    react_1.default.createElement(origyn_art_ui_1.Grid, { style: { width: "100%" }, columns: 3, gap: 24 },
                        react_1.default.createElement(origyn_art_ui_1.Flex, { fullWidth: true, flexFlow: "column", align: "center", gap: 24 },
                            react_1.default.createElement("h4", null, "Total Rewards"),
                            react_1.default.createElement("h2", null, rewards?.total)),
                        react_1.default.createElement(origyn_art_ui_1.Flex, { fullWidth: true, flexFlow: "column", align: "center", gap: 24 },
                            react_1.default.createElement("h4", null, "Redeemed rewards"),
                            react_1.default.createElement(origyn_art_ui_1.Flex, { as: "h2", gap: 8 }, rewards?.redeemed)),
                        react_1.default.createElement(origyn_art_ui_1.Flex, { fullWidth: true, flexFlow: "column", align: "center", gap: 24 },
                            react_1.default.createElement("h4", null, "Rewards in governance"),
                            react_1.default.createElement(origyn_art_ui_1.Flex, { as: "h2", gap: 8 }, rewards?.balance))))),
            react_1.default.createElement("br", null),
            react_1.default.createElement("br", null),
            react_1.default.createElement("br", null),
            react_1.default.createElement("br", null),
            react_1.default.createElement(origyn_art_ui_1.TabContent, { tabs: [
                    { id: 'Transactions', title: `Transactions History` },
                    { id: 'Governance', title: `Governance History` },
                    { id: 'inFlow', title: `In Flow` },
                    { id: 'outFlow', title: `Out Flow` },
                ], content: [
                    react_1.default.createElement(react_1.default.Fragment, null,
                        react_1.default.createElement(styled_components_1.ThemeProvider, { theme: isDarktheme ? themes_1.darkTheme : themes_1.lightTheme },
                            react_1.default.createElement(Section_1.default, { isLoading: isLoading },
                                react_1.default.createElement(SimpleTable_1.default, { dataFetching: (n, r) => getTransactions(n, r), initData: history, isPageLoading: isLoading, colWidth: {
                                        xs: 12,
                                        sm: 12,
                                        md: 12,
                                        lg: 12,
                                        xl: 12,
                                    } })))),
                    react_1.default.createElement(react_1.default.Fragment, null,
                        react_1.default.createElement(styled_components_1.ThemeProvider, { theme: isDarktheme ? themes_1.darkTheme : themes_1.lightTheme },
                            react_1.default.createElement(Section_1.default, { isLoading: isLoading },
                                react_1.default.createElement(SimpleTable_1.default, { noPagination: true, dataFetching: () => { }, initData: {
                                        data: governanceHistory.map((item) => ({ ...item, Action: [actionsTo[item.to[0].props.id] || actionsFrom[item.from[0].props.id] || ""] })),
                                        totalNumber: governanceHistory.length
                                    }, isPageLoading: isLoading, colWidth: {
                                        xs: 12,
                                        sm: 12,
                                        md: 12,
                                        lg: 12,
                                        xl: 12,
                                    } })))),
                    react_1.default.createElement(react_1.default.Fragment, null,
                        react_1.default.createElement(styled_components_1.ThemeProvider, { theme: isDarktheme ? themes_1.darkTheme : themes_1.lightTheme },
                            react_1.default.createElement(Section_1.default, { isLoading: isLoading },
                                react_1.default.createElement(SimpleTable_1.default, { noPagination: true, dataFetching: () => { }, initData: {
                                        data: outFlow,
                                        totalNumber: outFlow.length
                                    }, isPageLoading: isLoading, colWidth: {
                                        xs: 12,
                                        sm: 12,
                                        md: 12,
                                        lg: 12,
                                        xl: 12,
                                    } })))),
                    react_1.default.createElement(react_1.default.Fragment, null,
                        react_1.default.createElement(styled_components_1.ThemeProvider, { theme: isDarktheme ? themes_1.darkTheme : themes_1.lightTheme },
                            react_1.default.createElement(Section_1.default, { isLoading: isLoading },
                                react_1.default.createElement(SimpleTable_1.default, { noPagination: true, dataFetching: () => { }, initData: {
                                        data: inFlow,
                                        totalNumber: inFlow.length
                                    }, isPageLoading: isLoading, colWidth: {
                                        xs: 12,
                                        sm: 12,
                                        md: 12,
                                        lg: 12,
                                        xl: 12,
                                    } }))))
                ] })))));
};
exports.BorderedBanner = (0, styled_components_1.default)(origyn_art_ui_1.Banner) `
  border-right: 1px solid ${({ theme }) => theme.colors.BORDER};
`;
exports.NewCustomGraphWrap = styled_components_1.default.div `
  width: 100%;
  canvas {
    width: 100%!important;
  }
  & > div > div > div:first-child > div {
    font-size: 16px;
  }
  & > div > div > div:last-child > div {
    padding: 5px 12px;
    border-radius: 8px;
    margin: 0 5px;
  }
  & > div > div {
    padding: 0;
    height: auto;
    display: flex;
    align-items: flex-start;
    justify-content: flex-start;
  }
`;
exports.CustomGraphWrap = styled_components_1.default.div `
  width: 100%;
  canvas {
    width: 100%!important;
  }
`;
exports.default = UserTransactions;
